import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const LinkStyled = styled(Link)`
    margin-top: 1rem;
    font-size: 1.5rem;
    color: rgb(39 73 255);
`;
